"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const material_ui_confirm_1 = require("material-ui-confirm");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
function default_1({ roomId, recordFileChoice, recordField, expenseRecordFormSetValue, }) {
    const [isDeletingFile, setIsDeletingFile] = (0, react_1.useState)(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const deleteRecordFile = () => __awaiter(this, void 0, void 0, function* () {
        setIsDeletingFile(true);
        yield (0, api_1.deleteData)(`/api/v1/room/${roomId}/settlement-manage/expense/file-delete?field_type=${recordFileChoice}`)
            .then(() => {
            (0, functions_1.showToastMessage)({ message: t('삭제 완료') });
            expenseRecordFormSetValue(`${recordField}_filename`, undefined);
        })
            .catch(err => {
            var _a, _b, _c;
            const { status } = err.response;
            if (status === 403)
                (0, errors_1.handle403Error)(err);
            else if (status === 400) {
                const alertType = (_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.meta) === null || _c === void 0 ? void 0 : _c.alert_type;
                alert((0, errors_1.commonErrorMsg)(alertType) + '(failed to delete file)');
            }
            else
                alert((0, errors_1.commonErrorMsg)(status) + '(failed to delete file)');
        })
            .finally(() => setIsDeletingFile(false));
    });
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const confirmDeleteFile = () => {
        (0, functions_1.irreversibleDeleteConfirm)({ confirm, deleteFn: deleteRecordFile });
    };
    return ((0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ disabled: isDeletingFile, onClick: confirmDeleteFile }, { children: isDeletingFile ? ((0, jsx_runtime_1.jsx)("span", Object.assign({ css: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '16px',
                height: '16px',
                borderRadius: '8px',
                backgroundColor: 'var(--gray-20)',
            } }, { children: (0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 10, color: "info", thickness: 8 }) }))) : ((0, jsx_runtime_1.jsx)(svgs_1.XCircleGraySvg, { css: { width: '16px', height: '16px' } })) })));
}
exports.default = default_1;
